import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import moment from 'moment';
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { StableActivity } from '../_models/stableActivity';
import { StableActivityMultiple } from '../_models/stableActivityMultiple';

@Injectable()
export class StableActivityMultipleService {
  private apiBaseUrl = environment.apiBaseUrl;

  constructor(private http: HttpClient) {}

  getStableActivityMultiple(uuid): Observable<StableActivity[]> {
    return this.http
      .get<any>(this.apiBaseUrl + 'api/private/v1/stableActivityMultiple?uuid=' + uuid)
      .pipe(map((response) => response));
  }

  saveStableActivityMultiple(stableActivityItem, strategy): Observable<any> {
    const stableActivity = { ...stableActivityItem };
    delete stableActivity.lastUpdated;
    delete stableActivity.dateCreated;

    const dateFormatted = moment(stableActivity.activityDate).startOf('day').utc().toISOString();
    stableActivity.activityDate = dateFormatted
      ? dateFormatted.replace(':00Z', ':00.000Z')
      : ('' as any);

    if (stableActivity.multipleBoxes && stableActivity.multipleBoxes.length > 0) {
      stableActivity.multipleBoxes.forEach((box) => {
        delete box.name;
        delete box.productionOrientation;
      });
    }

    if (stableActivity.mixes) {
      const arrmixes: Array<any> = [];
      stableActivity.mixes.forEach((element) => {
        if (element.product) {
          const idproduct: any = {
            id: element.product.id,
          };
          element.product = idproduct;
        }
        arrmixes.push(element);
      });
      stableActivity.mixes = arrmixes;
    }
    if (stableActivity.equipments) {
      const arrequipments: Array<any> = [];
      stableActivity.equipments.forEach((element) => {
        const idequipment: any = {
          id: element.id,
        };
        arrequipments.push(idequipment);
      });
      stableActivity.equipments = arrequipments;
    }
    if (stableActivity.users) {
      const arrusers: Array<any> = [];
      stableActivity.users.forEach((element) => {
        const iduser: any = {
          id: element.id,
        };
        arrusers.push(iduser);
      });
      stableActivity.users = arrusers;
    }

    if (stableActivity.stable) {
      const idstable: any = {
        id: stableActivity.stable.id,
      };
      stableActivity.stable = idstable;
    }
    delete stableActivity.verificationDate;
    const companySelected = JSON.parse(localStorage.getItem('companySelected'));
    stableActivity.companyId = companySelected ? companySelected.id : null;

    if (stableActivity.id) {
      const strat = strategy ? '?strategy=' + strategy : '';
      return this.http
        .put(
          this.apiBaseUrl + 'api/private/v1/stableActivityMultiple/' + stableActivity.id + strat,
          stableActivity
        )
        .pipe(
          map((response: any) => {
            if (response) {
              return response;
            }
          })
        );
    } else {
      return this.http
        .post(this.apiBaseUrl + 'api/private/v1/stableActivityMultiple', stableActivity)
        .pipe(
          map((response: any) => {
            if (response) {
              return response;
            }
          })
        );
    }
  }

  deleteStableActivity(stableActivity): Observable<StableActivityMultiple> {
    return this.http
      .delete(this.apiBaseUrl + 'api/private/v1/stableActivityMultiple/' + stableActivity.id)
      .pipe(
        map((response) => {
          if (response) {
            return { id: stableActivity.id } as StableActivityMultiple;
          }
        })
      );
  }
}
